import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import MyLearnerOnboarding from 'bundles/onboarding-common/queries/MyLearnerOnboarding.graphql';
import type { MyLearnerOnboardingQuery } from 'bundles/onboarding-common/queries/__generated__/MyLearnerOnboarding';

/**
 * Shared hook for fetching learner onboarding data
 * Used by multiple onboarding-related hooks to avoid duplication
 */
const useLearnerOnboardingQuery = () => {
  const { data, loading, error } = useQuery<MyLearnerOnboardingQuery>(MyLearnerOnboarding, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
    onError: (error) => {
      Sentry.captureMessage('[onboarding-common]: Unable to fetch onboarding status', {
        extra: { error },
      });
    },
  });

  const hasSeenOnboarding = data?.LearnerOnboarding?.me?.hasSeenOnboarding;
  const onboardingVersion = data?.LearnerOnboarding?.me?.onboardingVersion;
  const lastSeenOnboardingTime = data?.LearnerOnboarding?.me?.lastSeenOnboardingTime;

  return {
    hasSeenOnboarding,
    onboardingVersion,
    lastSeenOnboardingTime,
    loading,
    error,
    data,
  };
};

export default useLearnerOnboardingQuery;
